import React from 'react'
import Header from '../constant/Header'
import Footer from '../constant/Footer'

const Layout = ({children}) => {
  return (
    <>
      <Header />
      {/* The 'children' is where the different pages (Shop, Contact) will load */}
      <main>{children}</main>
      <Footer />
    </>
  )
}

export default Layout